import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/site';
import { ui } from '../data/ui';
import { buttonClass } from '../utils/styles';
export function CtaSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy" data-id="element-33" data-mp="r14jw9lif417">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20" data-id="element-34" data-mp="qztde20oji6e">
        <div className="grid items-center gap-10 lg:grid-cols-[1.2fr_1fr]" data-id="element-35" data-mp="v1ofh8qfpzl8">
          <div data-id="element-36" data-mp="zswquabbrv11">
            <h2 className="max-w-xl font-display text-3xl leading-[1.15] text-white sm:text-4xl" data-id="element-37" data-mp="zt6ehr8wdq3k">
              {t({
              en: 'Ready to transform your space?',
              es: '¿Listo para transformar tu espacio?'
            })}
            </h2>
            <p className="mt-4 max-w-xl text-lg leading-relaxed text-navy-100" data-id="element-38" data-mp="19ozszg66ftnz">
              {t({
              en: 'Free estimate, no obligation, and an honest answer about what your project really needs. Call today and we will schedule your visit — often within 24 hours.',
              es: 'Presupuesto gratis, sin compromiso, y una respuesta honesta sobre lo que tu proyecto realmente necesita. Llama hoy y agendamos tu visita — muchas veces en 24 horas.'
            })}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-39" data-mp="39c3awgru7s4t">
              <Link to="/contact" className={buttonClass('gold', 'lg')} data-id="element-40" data-mp="9tk5nnabq5so">
                {t(ui.freeEstimateNow)}
              </Link>
              <a href={business.phoneHref} className={buttonClass('white', 'lg')} data-id="element-41" data-mp="4y4reu8em7vq">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="38vhj01r0dc" />
                {business.phoneDisplay}
              </a>
            </div>
          </div>

          <ul className="space-y-3" data-id="element-43" data-mp="slmliwf55i1v">
            <li data-id="element-44" data-mp="smo03avd8moc">
              <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex items-center gap-4 rounded-lg border border-white/15 bg-navy-800 p-4 transition-colors duration-150 ease-out-expo hover:border-gold" data-id="element-45" data-mp="sn7kcy8hnn5j">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#25D366]" data-id="element-46" data-mp="28couvrve9kpv">
                  <WhatsAppIcon className="h-5 w-5 text-[#0B3B22]" data-id="element-47" data-mp="2db9xfxy4cghh" />
                </span>
                <span data-id="element-48" data-mp="1zca9ksifk5md">
                  <span className="block text-sm text-navy-100/70" data-id="element-49" data-mp="1zbqzfxz0uliw">WhatsApp</span>
                  <span className="block font-semibold text-white" data-id="element-50" data-mp="24bmuh7pqr2mb">{business.phoneDisplay}</span>
                </span>
              </a>
            </li>
            <li data-id="element-51" data-mp="1pfnpi5xxhile">
              <a href={business.emailHref} className="flex items-center gap-4 rounded-lg border border-white/15 bg-navy-800 p-4 transition-colors duration-150 ease-out-expo hover:border-gold" data-id="element-52" data-mp="1pg77fmnkw6zf">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-53" data-mp="3or700oyvqyx6">
                  <MailIcon className="h-5 w-5 text-navy-deep" aria-hidden="true" data-id="element-54" data-mp="1d4mxcocicigr" />
                </span>
                <span className="min-w-0" data-id="element-55" data-mp="185tjgutb6pg2">
                  <span className="block text-sm text-navy-100/70" data-id="element-56" data-mp="182nurgoldpkv">Email</span>
                  <span className="block break-all font-semibold text-white" data-id="element-57" data-mp="1muppynfpvuek">{business.email}</span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}